import styled from 'styled-components';
import { Form } from 'antd';

export const StyledForm = styled(Form)`
  width: 400px;
`;
export const StyledTitle = styled.div`
  padding-bottom: 7px;
`;
export const EachColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
`;
export const StyledDescription = styled.p`
  margin-top: -5px;
  margin-bottom: 25px;
  padding-left: 75px;
  font-size: 0.65rem;
  font-weight: 400;
`;
